import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookingPdfHtmlComponent } from '../booking/booking-pdf-generator/booking-pdf-html.component';
import { Booking } from '../../core/models';

@Component({
  selector: 'app-booking-pdf-html-modal',
  imports: [CommonModule, BookingPdfHtmlComponent],
  standalone: true,
  template: `
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        class="bg-white dark:bg-surface max-w-5xl w-full mx-4 rounded-xl shadow-xl overflow-hidden"
      >
        <div
          class="flex justify-between items-center border-b border-border px-6 py-4"
        >
          <h2 class="text-lg font-semibold">Booking Preview</h2>
          <button
            (click)="close.emit()"
            class="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Close"
          >
            &#x2715;
          </button>
        </div>

        <div class="p-6 overflow-y-auto max-h-[80vh]">
          <app-booking-pdf-html [booking]="booking" />
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class BookingPdfHtmlModalComponent {
  @Input({ required: true }) booking!: Booking;
  @Output() close = new EventEmitter<void>();

  ngOnInit(): void {
    if (!this.booking) {
      throw new Error('BookingPreviewModalComponent requires a booking input');
    }
  }
}
